// This page has been temporarily removed for development. Authentication will be added later.
const Login = () => <div>Login page is disabled for now.</div>;
export default Login;
